   //gets lines and zone order for
   export function getMembersOf(resourceid: string){
    const query = [
      "SELECT ?memberOf",
      "{",
        "<" + resourceid + "> <http://scta.info/property/isMemberOf> ?memberOf . ",
      "}"].join(' ');
      return query
    }